module.exports = __webpack_public_path__ + "static/media/hospital.ca9646cd.svg";